import React from 'react';
import './componentsCSS/VersionsSelect.css';
import {CURRENT_VERSION_TEXT, VERSIONS_DATE_TEXT} from "../consts/consts";

interface VersionsSelectProps {
    versions: { version_id: string, timestamp: string }[];
    selectedVersion: string | null;
    setSelectedVersion: (version: string) => void;
}

const VersionsSelect: React.FC<VersionsSelectProps> = ({versions, selectedVersion, setSelectedVersion}) => {
    const handleVersionChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedVersion(event.target.value);
    };

    return (
        <div className="version-container">
            <div className="version-row">
                <label className="version-label">{CURRENT_VERSION_TEXT}</label>
                <select
                    className="version-dropdown"
                    value={selectedVersion || ""}
                    onChange={handleVersionChange}
                >
                    {versions.map(({version_id}) => (
                        <option key={version_id} value={version_id}>
                            {version_id}
                        </option>
                    ))}
                </select>
            </div>
            <div className="version-info">
                <u>{VERSIONS_DATE_TEXT}</u> : {versions.find(v => v.version_id === selectedVersion)?.timestamp || ""}
            </div>
        </div>
    );
};

export default VersionsSelect;